import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { errorMessage, successMessage } from 'lib/flash-message'
import * as api from 'store/api'

const InStockAlertButton = ({ buttonStyle, productId, text }) => {
  let [addingInStockAlert, setAddingInStockAlert] = useState(false)

  const handleClick = () => {
    setAddingInStockAlert(true)
    api
      .addProductAvailabilitySubscription(productId)
      .then(() => {
        successMessage("We'll email you when this item is back in stock!")
        setAddingInStockAlert(false)
      })
      .catch(() => {
        errorMessage()
        setAddingInStockAlert(false)
      })
  }

  return (
    <InfoButton
      block
      empty
      {...buttonStyle}
      onClick={handleClick}
      submitting={addingInStockAlert}
    >
      {text}
    </InfoButton>
  )
}

InStockAlertButton.propTypes = {
  buttonStyle: PropTypes.object,
  productId: PropTypes.number.isRequired,
  text: PropTypes.string,
}

InStockAlertButton.defaultProps = {
  text: 'Get in stock alert',
}

export default InStockAlertButton
